import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './PlantingWindowCal.css';


const getVisibleMonth = (startDate, endDate, currentDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const simulatedToday = new Date(currentDate.replace(/-/g, ' '));

    if (simulatedToday >= start && simulatedToday <= end) {
        return new Date(simulatedToday.getFullYear(), simulatedToday.getMonth(), 1);
    }

    return new Date(start.getFullYear(), start.getMonth(), 1);
};

function PlantingWindowCal({ startDate, endDate, currentDate }) {
    console.log('[PlantingWindowCal] props:', { startDate, endDate, currentDate });
    const [activeStartDate, setActiveStartDate] = useState(() =>
        getVisibleMonth(startDate, endDate, currentDate)
    );

    useEffect(() => {
        setActiveStartDate(getVisibleMonth(startDate, endDate, currentDate));
    }, [startDate, endDate, currentDate]);

    const highlightDates = (date) => {
        const start = new Date(startDate);
        const end = new Date(endDate);

        return date >= start && date <= end
            ? 'highlight-date'
            : null;
    };

    return (
        <div className="calendar-container">
            <Calendar
                activeStartDate={activeStartDate}
                value={null}
                tileClassName={({ date }) => highlightDates(date)}
                tileContent={() => <div tabIndex="-1" />}
                showNeighboringMonth={true}
                calendarType="gregory"
                locale="en-CA"
                nextLabel={null}
                prevLabel={null}
                next2Label={null}
                prev2Label={null}
            />
        </div>
    );
}

export default PlantingWindowCal;
